<template>
    <div class="AlgoliaSearchLocations locations">
        <h2>in</h2>
        <AlgoliaSearchLocationsDropdown
            :attribute="locationFacet"
            @refined="filteredLocations = []"
        />
        <SurroundingToggle
            class="surrounding-toggle"
            :surrounding="surrounding"
            regionFacet="regions.lvl1"
            surroundingFacet="surroundings.lvl1"
            @switch="switchLocationFacet"
        />
    </div>
</template>

<script>
// Import the EventBus.
import { EventBus } from '@utils/event-bus.js';

export default {
    data() {
        return {
            regionFacet: 'regions.lvl1',
            surroundingFacet: 'surroundings.lvl1',
            filteredLocations: [],
            locationFacet: 'regions.lvl1',
        };
    },

    computed: {
        surrounding() {
            return this.locationFacet === this.surroundingFacet;
        },

        searchParameters() {
            return {
                disjunctiveFacets: [this.regionFacet, this.surroundingFacet],
                disjunctiveFacetsRefinements: {
                    [this.locationFacet]: this.filteredLocations
                }
            };
        }
    },

    watch: {
        searchParameters() {
            this.$emit('update', this.searchParameters);
        }
    },

    created() {
        // Check url for checked surrounding
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('surroundings')) {
            this.locationFacet = this.surroundingFacet;
        }

        EventBus.$on('resetLocations', (params) => {
            this.switchLocationFacet(params);
        })
    },

    methods: {
        switchLocationFacet({ towns, surrounding }) {
            this.filteredLocations = towns;
            this.locationFacet = surrounding ? this.surroundingFacet : this.regionFacet;
        },
    }
};
</script>

<style lang="scss" scoped>
    .locations {
        position: relative;
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: flex-end;

        h2 {
            font-size: 2rem;
            font-weight: 300;
            color: #000;
            font-family: $fancy-font-family;
            margin-left: 1rem;
            margin-right: 1rem;

            &:not(:first-child) {
                font-size: 50px;
                flex: 0;
                margin: 0 0.5em;

                 @include media-query(portable) {
                    display: none;
                }
            }

            @include media-query(portable) {
                font-size: 2.5rem;
                position: relative;
                top: 5px;
            }

            @include media-query(smart) {
                margin-left: 0.5rem;
                margin-right: 0.5rem;
            }
        }

        @include media-query(desk) {
            margin-top: 3px;
        }
    }

    .surrounding-toggle {
        position: absolute;
        bottom: -35px;
        right: 0;

        @include media-query(smart) {
            bottom: -28px;
        }
    }
</style>
